import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    content: {
        padding: theme.spacing.unit * 3,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    }
});

class AppContent extends React.Component {
    render() {
        const { classes, children } = this.props;
        return (<div className={classes.content}>{children}</div>)
    }
}

AppContent.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AppContent);


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/Layout/AppContent.js